<template>
  <div class="vcom-survey-page-template">
    <IframeComponent
      @onLoad="onSurveyLoad"
      class="survey-iframe"
      :srcUrl="url"
    />
    <div
      class="survey-instruction"
    >Please be sure you have completed all survey questions above before selecting the Next button.</div>
    <div class="input-wrapper" style="justify-content: center;">
      <Button
        @click="nextPage"
        :disabled="!isNextEnabled"
        style="margin-top: 10px;"
        long
        size="large"
        type="primary"
      >Next</Button>
    </div>
  </div>
</template>

<script>
import IframeComponent from "@/components/IFrameComponent";
export default {
  name: "VCOMSurveyPage",
  components: { IframeComponent },
  props: ["url"],
  data() {
    return {
      isNextEnabled: false
    };
  },
  methods: {
    onSurveyLoad() {
      setTimeout(() => {
        this.isNextEnabled = true;
      }, 10000);
    },
    nextPage() {
      this.$emit("nextPage");
    }
  }
};
</script>

<style lang="scss" scoped>
.vcom-survey-page-template {
  height: 100%;
}
.survey-iframe {
  height: 70vh;
}
.survey-instruction {
  font-size: 14px;
  color: red;
}
</style>